export default [
    {
        path: '/report',
        name: 'report',
        component: () => import(/* webpackChunkName:'di'*/ '@/views/report/base/BaseReportTab.vue'),
        meta: {},
    },
    {
        path: '/report-template-file',
        name: 'reportTemplateFile',
        component: () => import(/* webpackChunkName:'report'*/ '@/views/reportTemplateFile/ReportTemplateFile.vue'),
        meta: {},
    },
];
